/** @jsx jsx */

import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { Button, } from '@argo/ui-elements';
import { colors, typography, } from '@argo/principles';
import Award from './Award';
import { VehicleAward, } from '../../sew-core/types';


const Container = styled.div`
  width: 100%;
  padding-bottom: 16px;
`;

const Divider = styled.div`
  border: none;
  border-bottom: 1px solid #ddd;
  width: 100%;
  padding-top: 24px;
  margin-bottom: 33px;
`;

const AwardContainer = styled.div`
  max-width: 450px;
  text-align: center;
  button {
    span {
      ${typography.types.bodySmall}
      font-weight: ${typography.weight.semiBold};
      font-size: 10px;
      line-height: 16px;
      color: ${colors.action.brightBlue};
    }
  }
`;

type Props = {
  vehicleAward: VehicleAward;
  onAwardsInfoClick: () => void;
  openOverlay: (overlayHeader: string) => void;
}

export default ({ vehicleAward, onAwardsInfoClick, openOverlay, }: Props,): JSX.Element => {
  const { awards, } = vehicleAward;
  return (
    <Container>
      {awards.map((award, index,) => (
        <AwardContainer key={`${award.awardCode}${award.awardName}`}>
          <Divider style={{ display: index !== 0 ? 'flex' : 'none', }} />
          <Award award={award} />
          <Button
            buttonType="text"
            enableCapitalize={false}
            text="Award Info"
            onClick={() => {
              openOverlay(award.awardName,);
              onAwardsInfoClick();
            }}
          />
        </AwardContainer>
      ),)}
    </Container>
  );
};
